import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import Helmet from 'react-helmet';
import { FacebookShareButton } from 'react-share';


const Post = ({title, image, date, slug, content}) => {
  const months = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
  const dateObject = new Date(date);
  const dateString = `${dateObject.getFullYear()} ${months[dateObject.getMonth()]} ${dateObject.getDate()}.`;

  return (
    <div className="post fade-in">

      <Helmet>
        <title>{`${ReactHtmlParser(title)} | Berki Melinda`}</title>
      </Helmet>

      <div className="post-share-buttons">
        <FacebookShareButton url={`${window.location.origin}/blog/${slug}`}>
          <i className="fab fa-facebook-f"></i>
        </FacebookShareButton>
      </div>

      <h2>{ReactHtmlParser(title)}</h2>
      {dateString}

      <img src={image.full} alt={slug} className="mt-3 mb-5 w-100" />
      <div className="post__content">
        {ReactHtmlParser(content)}
      </div>

    </div>
  );
};


Post.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Posts/Post.js